import { createSlice } from '@reduxjs/toolkit';
import { PRC_MEETING_SUMMARY_TABLES_KEYS } from '../constants';

const INITIAL_STATE = {
  selectedKeys: PRC_MEETING_SUMMARY_TABLES_KEYS.ALL,
};

const pdcSummaryTableViewtSlice = createSlice({
  name: 'pdcSummaryTableView',
  initialState: { ...INITIAL_STATE },
  reducers: {
    setSelectedKey: (state, action) => {
      state.selectedKeys = action.payload;
    },
  },
});
const { actions, reducer: pdcSummaryTableViewReducer } = pdcSummaryTableViewtSlice;
export const { setSelectedKey } = actions;
export default pdcSummaryTableViewReducer;
